import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faExclamationTriangle, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { useStyles } from './mecha_alert_banner_styles';

const MechaAlertBanner = (props) => {
    const { content, contentBold, startNewQuote, header, dataId, justify, darkRed, iconShape } = props;
    const classes = useStyles({ justify, darkRed });

    let icon;
    switch (iconShape) {
        case 'triangle':
            icon = faExclamationTriangle;
            break;
        case 'cross':
            icon = faTimes;
            break;
        case 'circle':
        default:
            icon = faExclamationCircle;
    }

    return (
        <div className={classes.mecha_alert_banner_wrapper} data-id={dataId}>
            <FontAwesomeIcon
                icon={icon}
                className={classes.mecha_alert_banner_icon}
            />
            <div className={classes.mecha_alert_banner_content_wrapper}>
                <p className={classes.mecha_alert_banner_header}>{header}</p>
                <p className={classes.mecha_alert_banner_content}>
                    {content}
                    <span className={classes.bold_content}>{contentBold}</span>
                    or <a className={classes.linkText} onClick={startNewQuote}>start a new quote.</a>
                </p>
            </div>
        </div>
    );
};

MechaAlertBanner.propTypes = {
    header: PropTypes.string,
    content: PropTypes.string.isRequired,
    contentBold: PropTypes.string,
    startNewQuote: PropTypes.func,
    dataId: PropTypes.string,
    justify: PropTypes.string,
    darkRed: PropTypes.bool,
    iconShape: PropTypes.oneOf(['circle', 'triangle', 'cross'])
};

export { MechaAlertBanner };
